module.exports = __webpack_public_path__ + "img/chevron-right.1bb99a05.svg";